import { PublicClientApplication } from "@azure/msal-browser";

/** MSAL の初期化設定 */
const msalConfig = {
	auth: {
		clientId: process.env.VUE_APP_CLIENTID,
		authority: `https://login.microsoftonline.com/${process.env.VUE_APP_TENANTID}`,
		redirectUri: process.env.VUE_APP_REDIRECT_URL,
		navigateToLoginRequestUrl: true,
	},
	cache: {
		cacheLocation: "sessionStorage",
		storeAuthStateInCookie: false,
	},
};

export const msalInstance = new PublicClientApplication(msalConfig);

// 初期化保証（多重呼び出しを1回に収束）
let __initDone = false;
let __initPromise = null;
export async function ensureMsalInitialized() {
	if (__initDone) return;
	if (!__initPromise) {
		__initPromise = msalInstance
			.initialize()
			.then(() => {
				__initDone = true;
			})
			.finally(() => {
				__initPromise = null;
			});
	}
	await __initPromise;
}

/**
 * サインイン状態を1コールで保証（初期化→リダイレクト結果処理→ActiveAccount 設定）
 * - 未サインインなら loginRedirect（同意/サインイン）へ遷移
 * - 復帰後（redirect 戻り）に再度呼べば ActiveAccount 設定まで完了
 */
export async function ensureSignedIn() {
	await ensureMsalInitialized();
	await msalInstance.handleRedirectPromise();
	const accounts = msalInstance.getAllAccounts();
	if (accounts.length === 0) {
		await msalInstance.loginRedirect({
			scopes: [process.env.VUE_APP_API_SCOPE, "openid", "profile"],
			redirectStartPage: window.location.href,
		});
		return false; // ←ここ重要
	}
	msalInstance.setActiveAccount(accounts[0]);
	return true;
}

/**
 * acquireTokenSilent() 用の最小リクエスト
 * - ActiveAccount（なければ最初のアカウント）と API スコープを返す
 */
export function getSilentRequest() {
	const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
	if (!account) throw new Error("No signed-in account");
	return { account, scopes: [process.env.VUE_APP_API_SCOPE] };
}
